import { useState } from "react";
import { toAbsoluteUrl } from "../../../../_metronic/helpers";

import { useLocation } from "react-router-dom";
import { Link, useNavigate } from "react-router-dom";
import { upiSubmit } from "../../api";

/**
 * AddUpiDetails component displays UPI details for user confirmation and submission.
 * Handles formatted display, navigation, and KYC submission logic for UPI.
 */
const AddUpiDetails = ({ login = null }) => {
  const [disbale, setDeisbale] = useState(false);
  const location = useLocation();
  const gpaydetails = location.state?.gpaydetails || "";
  const id = location.state?.id || "";
  const userId = location.state?.userId || "";
  const navigate = useNavigate();
  const [redirectUrl] = useState(login ? 'customer' : 'customerCard')
  function formatKey(key) {
    // Split the key by underscores, capitalize each part, and join with spaces
    return key
      .replace(/nameAtBank/g, "Name at Bank")
      .replace(/accountExists/g, "Account Exists")
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  }
  const upiKycSubmit = () => {
    setDeisbale(true)
    let data = {
      'upi_id': id,
      'iirpl_sap_code': userId,
      'apiresponse': gpaydetails
    }
    upiSubmit(data)
      .then((d) => {
        navigate(`/${redirectUrl}/upi-details-success/${userId}`);
      })
      .catch((error) => {
        if (error.response.status === 404) {
          alert(error.response.message)
        } else {
          // Handle other errors
          console.error("Error:", error);
        }
      });
  }
  return (
    <>
      <div className="container mt-4">
        <div className="row">
          <div className="col-md-12 pancard-data">
            <div className="text-center mb-7">
              <img
                width="100"
                alt="icon"
                src={toAbsoluteUrl("/media/images/pan-check.png")}
              />
              <h6 className="mt-5">UPI is Valid</h6>
            </div>

            <div className="px-2">
              <h4 className="mb-5">Details Entered As Per You</h4>
              <label>UPI ID</label>
              <p>{id}</p>
            </div>
            <div className="card_data">
              <h6>Details As Per The UPI</h6>
              <div className="details_card d-flex flex-wrap">
                {typeof gpaydetails === "object" &&
                  Object.entries(gpaydetails).map(([key, value]) => (
                    <div key={key}>
                      <label>{formatKey(key)}:</label> <p>{value}</p>
                    </div>
                  ))}
              </div>
            </div>

            <div className="mt-15 d-flex justify-content-between">
              <Link to={`/${redirectUrl}/add-upi/${userId}`}>
                <button style={{ background: '#112845' }} className="btn  btn-lg w-150px text-white">Back</button>
              </Link>

              {/* <Link to={`${redirectUrl}/pancard-uploded/${userId}`}>
               
              </Link> */}
              <button disabled={disbale} className="btn btn-danger btn-lg btn-hover-success w-150px text-white" onClick={() => upiKycSubmit()}>Submit</button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddUpiDetails;
